import type { ReactNode } from 'react'
import { Dialog } from '../ui/overlays.js'
import { Button } from '../ui/primitives.js'
import type { IconName } from '../ui/icons.js'

interface ConfirmDialogProps {
  title: string
  message: ReactNode
  confirmLabel: string
  cancelLabel: string
  busy?: boolean
  danger?: boolean
  icon?: IconName
  onConfirm: () => void
  onCancel: () => void
}

/** The "are you sure" step publishing, trashing and leaving with a draft need. */
export function ConfirmDialog({ title, message, confirmLabel, cancelLabel, busy, danger, icon, onConfirm, onCancel }: ConfirmDialogProps) {
  return <Dialog
    title={title}
    icon={icon ?? (danger ? 'warning' : undefined)}
    onClose={onCancel}
    dismissible={!busy}
    actions={<>
      <Button variant="text" onClick={onCancel} disabled={busy}>{cancelLabel}</Button>
      <Button variant={danger ? 'danger' : 'filled'} onClick={onConfirm} disabled={busy} data-autofocus>{confirmLabel}</Button>
    </>}
  >
    <div className="dialog-message">{message}</div>
  </Dialog>
}
